/** Static fallbacks when MongoDB site settings have no uploaded media */
export const LOCAL_DEFAULTS = {
  brandLogo: '/assets/brand/logo.png',
  introLogo: '/assets/brand/logo.png',
  introVideo: '',
};

export default LOCAL_DEFAULTS;
